import { GoogleMapsModule } from '@angular/google-maps';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrButtonConfirmModule } from '@app/components/pr-button/pr-button-confirmation/pr-button-confirm.module';
import { PrButtonDropdownModule } from '@app/components/pr-button/pr-button-dropdown/pr-button-dropdown.module';
import { PrButtonModule } from '@app/components/pr-button/pr-button/pr-button.module';
import { PrIconModule } from '@app/components/pr-icon/pr-icon.module';
import { PrTableModule } from '@app/components/pr-table/pr-table.module';
import { PrTableFormAddComponent } from './pr-table-form-add/pr-table-form-add.component';
import { PrTableFormComponent } from './pr-table-form.component';

export const DATE_PICKER_FORMAT = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

let COMPONENTS = [PrTableFormComponent, PrTableFormAddComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    GoogleMapsModule,
    PrTableModule,
    FormsModule,
    ReactiveFormsModule,
    PrButtonConfirmModule,
    PrButtonModule,
    PrButtonDropdownModule,
    PrIconModule,
  ],
  exports: COMPONENTS,
})
export class PrTableFormModule {}
